import LayoutActividad from "../../../components/LayoutActividad";
import { modulo12 } from "../../../routes/Module12";
import Sidebar from "../Sidebar";

import Imagen1 from "../../../images/modulo12/caras.png";
import Imagen2 from "../../../images/modulo12/dialogo.png";
import Imagen3 from "../../../images/modulo12/trompo.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad9 = () => {
  const infoUnidad = modulo12.content[1];
  const infoAct = modulo12.content[1].activities[11];
  const crumbs = [
    {
      title: modulo12.title,
      url: "/" + modulo12.url,
    },
    {
      title:
        modulo12.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titlePrev: `${modulo12.content[1].name}: ${modulo12.content[1].activities[10].name}`,
    linkPrev: `${modulo12.url}/${modulo12.content[1].path}/${modulo12.content[1].activities[10].path}`,
    titleNext: `${modulo12.content[2].name}: ${modulo12.content[2].activities[0].name}`,
    linkNext: `${modulo12.url}/${modulo12.content[2].path}/${modulo12.content[2].activities[0].path}`,
  };
  const metadata = {
    color: modulo12.color,
    title: `${modulo12.title} - ${infoAct.name}`,
    name: modulo12.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-3 p-md-5 p-md-5 mt-5">
        <h2>¿Cómo llegamos a acuerdos siendo diferentes?</h2>
        <div className="row align-items-center mt-4">
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              El Perú es un país donde existen muchas diferencias. A pesar de
              ello, todos somos <strong>iguales</strong> ante la ley.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen1} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid" alt="Peruanos" />
          </div>
          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              En medio de tanta diferencia, es importante que seamos capaces de
              escuchar y aceptar las <strong>opiniones</strong> de los demás
              para entendernos y llegar a acuerdos.
            </p>
          </div>

          <div className="col-md-8 col-12 p-4 p-md-3">
            <p>
              El <strong>diálogo</strong> es necesario para tomar decisiones que
              beneficien a todos y nos permitan <strong>convivir</strong> de
              manera pacífica.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen3} className="img-fluid" alt="Peruanos" />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>Luego léalo en voz alta.</li>
          <li>
            Pregunte a niños y niñas qué significan las palabras destacadas:
            “iguales”, “opiniones”, “diálogo” y “convivir”, y por qué creen que
            son importantes.
          </li>
          <li>
            Cierre la unidad resaltando la importancia de dialogar. Resalte que
            cuando hay más de un punto de vista, es importante escuchar la
            opinión de los demás y evaluar nuestra opinión ya sea para
            enriquecerla y reafirmarla o para cambiarla.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad9;
